import { Avatar } from 'antd'
import { useInterval } from 'ahooks'
import React, { useEffect, useState } from 'react'

const Item: React.FC<any> = (({ avatar, index }) => {
  const [count, setCount] = useState(index)
  const lefts = ['left-0', 'left-15', 'left-30']

  useInterval(() => {
    setCount(count - 1);
  }, count > -1 ? 2000 : undefined);

  return (
    <img
      className={`
    absolute -ml-4 rounded-full w-24 h-24
    ${count !== -1 ? count < 3 ? lefts[count] : 'left-46 opacity-0' : '-left-15 opacity-0'}
  `}
      src={avatar}
      style={{
        "border": "1px solid #fff",
        "transition": "all 1s ease-in-out",
        zIndex: 3 - count % 3
      }}
    />
  )
})

const AvatarCarousel: React.FC<any> = ({ kindsData, inquiryUsers }) => {

  return (
    <div
      id='AvatarCarousel'
      className='relative w-60 h-24 whitespace-pre'>
      {Array.isArray(inquiryUsers) && inquiryUsers.length > 0 &&
        Array(40).fill().flatMap(() => inquiryUsers).map(
          (item: { avatar: string }, index: number) => (
            <Item key={index} avatar={item.avatar} index={index} />
          )
        )}
    </div>
  )
}
export default AvatarCarousel